export default __webpack_public_path__ + "static/media/mobile.045455b2.svg";